<template>
  <div class="content-page demo-page">
    <PageHero
      :eyebrow="page.hero.eyebrow"
      :title="page.hero.title"
      :lede="page.hero.lede"
      :note="page.hero.note"
      :actions="page.hero.actions"
      :aside="page.hero.aside"
    />

    <PageSection
      v-if="page.highlights && page.highlights.length"
      heading="What to notice"
    >
      <div class="shift-panels">
        <article
          v-for="highlight in page.highlights"
          :key="highlight.title"
          class="shift-panel"
        >
          <span class="label">{{ highlight.label }}</span>
          <h3 class="shift-panel__question">{{ highlight.title }}</h3>
          <p class="shift-panel__answer">{{ highlight.text }}</p>
        </article>
      </div>
    </PageSection>
  </div>
</template>

<script setup>
import PageHero from '@/components/PageHero.vue'
import PageSection from '@/components/PageSection.vue'
import { demoLandingPage as page } from '@/config/demo'
</script>
